export const initPopupToggle = () => {
  const touchIcons = document.querySelectorAll('.touchicon');
  const popups = document.querySelectorAll('.popup .content');

  // モーダルを開く処理
  touchIcons.forEach((touchIcon) => {
    const id = touchIcon.getAttribute('data-id');
    touchIcon.addEventListener('click', () => {
      const correspondingPopup = document.querySelector(`.popup .content[data-id="${id}"]`);

      if (correspondingPopup) {
        // すべてのモーダルを閉じる
        popups.forEach((popup) => popup.classList.remove('-active'));

        // 対応するモーダルを開く
        correspondingPopup.classList.add('-active');
      }
    });
  });

  // モーダルを閉じる処理 (×ボタン)
  const closeButtons = document.querySelectorAll('.popup .close');
  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      const correspondingPopup = closeButton.closest('.content');
      if (correspondingPopup) {
        correspondingPopup.classList.remove('-active');
      }
    });
  });

  // モーダル外をクリックして閉じる処理
  document.addEventListener('click', (event) => {
    popups.forEach((popup) => {
      if (popup.classList.contains('-active')) {
        if (!popup.contains(event.target) && !event.target.closest('.touchicon')) {
          popup.classList.remove('-active');
        }
      }
    });
  });
};
